/*
 * @Author: Chao Yang
 * @Date: 2020-05-20 09:21:43
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-05-20 16:56:40
 */

import { Component, Input, TemplateRef } from '@angular/core';
import { AdTabMenuItem } from './ad-tab-menu-item';

@Component({
  template: ``,
  selector: 'ad-tab-menu-item',
})
export class AdTabMenuItemComponent extends AdTabMenuItem {
  @Input() value: string; // *required */
  @Input() text: string;
  @Input() disabled = false;
  @Input() textTpl: TemplateRef<any>;
  @Input() moveBtnTpl: TemplateRef<any>;
  @Input() actived = false;
  @Input() data: any;
  @Input() cssClass: string = '';
}
